
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 1.5a1.5 1.5 0 113.001.001A1.5 1.5 0 017 1.5zm0 6a1.5 1.5 0 113.001.001A1.5 1.5 0 017 7.5zm0 6a1.5 1.5 0 113.001.001A1.5 1.5 0 017 13.5z"}})])
          )
        }
      }
    